import { useFormErrorNotification } from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";

type UseAskAIFeedbackParams = {
	queryId: string;
	shopId: string;
	userIsOkWithAnswer: boolean;
};

export function useAskAIFeedback() {
	const mutation = $api.useMutation(
		"patch",
		"/shops/{shopId}/ask/{queryId}/feedback",
	);

	const errorNotification = useFormErrorNotification();

	return useMutation({
		onError: () => errorNotification(),
		mutationFn: async (data: UseAskAIFeedbackParams) => {
			return mutation.mutateAsync({
				params: { path: { queryId: data.queryId, shopId: data.shopId } },
				body: {
					userIsOkWithAnswer: data.userIsOkWithAnswer,
				},
			});
		},
	});
}
